import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IslandTravelUmbrellaIcon = /*#__PURE__*/memo(function (_ref) {
  var stroke = _ref.stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 24 24"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_3410_39335)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.184 11.51l-2.551 6.017M15.541 3.584a7.314 7.314 0 014.178 8.734l-.066.232a1.746 1.746 0 01-2.361 1.13L7.064 9.338a1.746 1.746 0 01-.828-2.484l.121-.21a7.315 7.315 0 019.184-3.06v0z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.543 3.582l.226.916a9.32 9.32 0 01-1.609 7.85v0M15.541 3.582l-.816.473a9.322 9.322 0 00-4.53 6.611v0M3 20.001a8.5 8.5 0 0112.02 0"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3410_39335",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H24V24H0z"
        })
      })
    })]
  }));
});
export default IslandTravelUmbrellaIcon;